
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/edit-profile",
      function () {
        return require("private-next-pages/companies/edit-profile.tsx");
      }
    ]);
  